import React, { useMemo, useState, useRef  ,useEffect, useReducer, fetchData} from 'react';
import { Alert, Button, Container, Card, Table, Modal, Accordion,Form, FormLabel, Col, Row } from 'react-bootstrap';

import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import useBackend, {XLogOff, IsLoggedIn, Loading, SpinnerX, CallDownload} from '../../services/useBackend_v2';
import MaterialReactTable from 'material-react-table';
import {getOptions} from '../../services/misc';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { FaFilePdf, FaReceipt, FaEnvelope,FaBars, FaUser, FaFileDownload, FaDownload } from 'react-icons/fa';

import download from 'downloadjs'
import { Link } from 'react-router-dom';

function SellReport() {

    const {loading, data, Refresh, Seek, initReady} =  useBackend('/api/reports');

    const [resultVariant, setResultVariant] = useState(null);
    const [resultText,    setResultText]    = useState(null);
    const [resultVisible, setResultVisible] = useState(null);

    async function handleExportData(filename, path) {        
        setResultVisible(true);
        setResultText("Påbörjar nedladdning...");
        setResultVariant("info");
        const csv = await CallDownload(path);
        download(csv, filename, 'text/csv')

        setResultText("Nedladdning klar!");

        setTimeout(() => {
            setResultVisible(false);
        }, 3000);     
    };  

    if (initReady) {
        return (
                <ContentWrapper>
                <Container>
                    <Sida>
                        <Rubrik>Rapporter</Rubrik>

                        {!loading &&(<>
                            <ul>
                                {data.reportList.map((p) => (<li>
                                    {p.isDownload===true ? 
                                        <a className="text-decoration-none" style={{color:'#000', fontSize:'20px'}}  onClick={() => {handleExportData(p.filename, p.path)}}>{p.name} </a>
                                    :
                                        <a className="text-decoration-none" style={{color:'#000', fontSize:'20px'}} href={p.path}>{p.name}</a>
                                    }
                                </li>))}
                            </ul>
                        </>)}
                        <Alert show={resultVisible} variant={resultVariant} className="FormSpace">{resultText}</Alert>
                    </Sida>
                </Container>
            </ContentWrapper>        
        )
    } else {
        return (<Loading />);        
    }
}

export default SellReport;